<div class="modal-wrapper">
  <div class="modal-header">
    @if (headerIcon) {
      <img [ngSrc]="headerIcon" width="32" height="32" alt="Success vinculation icon" />
    }
    <h1 mat-dialog-title class="modal-header__title">{{ headerTitle }}</h1>
    <img ngSrc="images/header-logo.svg" class="modal-header__logo" alt="" width="267" height="267" />
  </div>
  <mat-dialog-content class="modal-body">
    <span class="modal-body__message" [ngClass]="messageClass" [innerHTML]="messageHtml"></span>
    @if (disclaimerText) {
      <div class="modal-body__disclaimer">
        <ion-icon name="information-circle-outline"></ion-icon>
        <span>{{ disclaimerText }}</span>
      </div>
    }
  </mat-dialog-content>
  <mat-dialog-actions class="modal-actions">
    <iahoy-link-button mat-dialog-close [text]="cancelLabel ?? 'Cerrar'" (click)="onCancel()"> </iahoy-link-button>
    @if (actionLabel) {
      <iahoy-button (click)="onAction()" [variant]="buttonType" size="medium" [disabled]="loading">{{
        actionLabel
      }}</iahoy-button>
    }
  </mat-dialog-actions>
</div>
